import React from 'react';
import Avatar from '../atoms/Avatar';
import InfoText from '../atoms/InfoText';
import TitleText from '../atoms/TitleText';
import { Rate } from 'antd';

export type ReviewCardProps = {
  title?: string;
  reviewerImage?: string;
  reviewerName?: string;
  reviewerRoleAndDate?: string;
  rating?: number | null;
  attachments?: React.ReactNode;
  notes?: React.ReactNode;
  className?: string;
};

const ReviewCard = ({
  title,
  reviewerImage,
  reviewerName,
  reviewerRoleAndDate,
  rating,
  attachments,
  notes,
  className,
}: ReviewCardProps) => {
  return (
    <div
      className={`p-4 rounded-xl bg-[#FAFAFA] dark:bg-gray-800 flex flex-col gap-2 ${className || ''}`}
      data-testid="review-card"
    >
      {title && (
        <TitleText
          text={title}
          className="!font-bold !text-base !text-[#090909] dark:!text-dark-text-primary"
          data-testid="review-card-title"
        />
      )}

      {/* Buyer profile and rating */}
      <div className="flex flex-col gap-3" data-testid="buyer-profile-row">
        <Avatar
          image={reviewerImage || ''}
          title={reviewerName || '---'}
          subTitle={
            <div className="flex flex-wrap items-center gap-2">
              {reviewerRoleAndDate && (
                <InfoText
                  text={reviewerRoleAndDate}
                  className="text-center lg:text-start !text-[#777777] dark:!text-dark-text-secondary !leading-[100%]"
                />
              )}
              {rating !== null && rating !== undefined && (
                <div className="flex items-center gap-1.5" data-testid="review-rating-container">
                  <Rate value={rating} disabled allowHalf />
                  <InfoText
                    text={`(${Number(rating).toFixed(1)})`}
                    className="!text-base !text-[#090909] dark:!text-dark-text-primary !font-semibold"
                    maxLength="FULL"
                    data-testid="review-rating-score"
                  />
                </div>
              )}
            </div>
          }
          withoutBorder={false}
          imageSize={48}
          className="!flex-row !items-center gap-3"
          data-testid="review-requester-avatar"
        />
      </div>

      {/* Attachments */}
      {attachments && (
        <div className="flex gap-2 mt-1" data-testid="review-card-attachments">
          {attachments}
        </div>
      )}

      {/* Notes */}
      {notes && (
        <div className="mt-1" data-testid="review-card-notes">
          {typeof notes === 'string' ? (
            <InfoText
              text={notes}
              className="!text-base !leading-[100%] !text-[#090909] dark:!text-dark-text-secondary"
              maxLength={250}
              data-testid="review-card-notes-text"
            />
          ) : (
            notes
          )}
        </div>
      )}
    </div>
  );
};

export default ReviewCard;
